<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="isotr11226" :items="this.listIsotr11226" label="Historial" item-text="fecha"
                              return-object required></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-if="this.isotr11226!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.isotr11226.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación: {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad: {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa: {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo: {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Posturas y movimientos ISO/TR 11226</div>
                    </template>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>Posturas y movimientos ISO/TR 11226</h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Preguntas clave
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Identificación del peligro
                                        <br/>Pregunta Clave
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>IDENTIFICACIÓN DEL PELIGRO ERGONÓMICO POR POSTURAS FORZADAS Y MOVIMIENTOS
                                    FORZADOS</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>Marque con una “X” la respuesta a cada una de las siguientes condiciones</b>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" bgcolor="#CCCCAA">
                                <b>En el puesto de trabajo hay alguna tarea que presente alguna de las siguientes
                                    condiciones:</b>
                            </td>
                            <td align="center" bgcolor="#CCCCAA">Respuesta</td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >1. ¿Durante la jornada de trabajo, hay presencia de una postura de trabajo estática
                                (mantenida durante 4 segundos consecutivamente) del tronco y/o de las extremidades,
                                incluidas aquellas con un mínimo de esfuerzo de fuerza externa?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch1"
                                          :label="`${this.isotr11226.switch1 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >2. ¿Durante la jornada de trabajo, se realiza una postura de trabajo dinámica del tronco,
                                y/o de los brazos, y/o de la cabeza, y/o del cuello y/o de otras partes del cuerpo?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch2"
                                          :label="`${this.isotr11226.switch2 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CF6D6D">
                                <b>Si alguna de las respuestas es “SI”, hay presencia del peligro por posturas forzadas
                                    y movimientos forzados y se debe realizarse una evaluación específica del
                                    riesgo.</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#ABCF6D">
                                <b>Si todas las respuestas a las condiciones son “NO”, no hay presencia del peligro por
                                    posturas y movimientos forzados.</b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Evaluación Rápida
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <!--Evaluacion rapida-->
                    <table border="1" style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                <b>
                                    <center>Preguntas para determinar si el riesgo por postura ESTÁTICA es aceptable o
                                        está en la ZONA VERDE
                                    </center>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>¿Está el tronco inclinado (flexión o extensión) a un angulo &gt; 20° sin apoyo
                                completo?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch3"
                                          :label="`${this.isotr11226.switch3 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿Está el cuello flexionado o en extensión por &gt; 25° sin apoyo completo del tronco?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch4"
                                          :label="`${this.isotr11226.switch4 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿Está la cabeza inclinada a un ángulo entre &gt; 85° o &gt; 25° sin apoyo completo del
                                tronco?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch5"
                                          :label="`${this.isotr11226.switch5 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿Está el brazo elevado a un ángulo de &gt; 60° o &gt; 20° sin un apoyo completo del
                                brazo?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch6"
                                          :label="`${this.isotr11226.switch6 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>e</td>
                            <td>¿El codo está en flexión o extensión extrema, o en pronación o supinación extrema?</td>
                            <td>
                                <v-switch v-model="isotr11226.switch7"
                                          :label="`${this.isotr11226.switch7 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si a
                                <b>todas</b> las preguntas ha contestado
                                <b>"SI"</b> entonces la tarea tiene un riesgo aceptable y está en la
                                <b>ZONA VERDE</b>.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si
                                <b>una</b> o más respuestas son
                                <b>"NO"</b>, compruebe si se trata de una tarea con un nivel de riesgo inaceptable según
                                la siguiente tabla.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table border="1" style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                <b>
                                    <center>Preguntas para determinar si el riesgo por postura DINÁMICA es aceptable o
                                        está en la ZONA VERDE
                                    </center>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>¿El tronco realiza (flexión o extensión) a un angulo &gt; 20°?</td>
                            <td>
                                <v-switch v-model="isotr11226.switch8"
                                          :label="`${this.isotr11226.switch8 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿El tronco realiza flexiones laterales o torsión &gt; 10°?</td>
                            <td>
                                <v-switch v-model="isotr11226.switch9"
                                          :label="`${this.isotr11226.switch9 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿La cabeza se inclina lateralmente por &gt; 10°, y/o realiza torsión de cuello por &gt;
                                45°?
                            </td>
                            <td>
                                <v-switch v-model="isotr11226.switch10"
                                          :label="`${this.isotr11226.switch10 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿El cuello se flexiona por fuera del rango de los 0° y los 40°?</td>
                            <td>
                                <v-switch v-model="isotr11226.switch11"
                                          :label="`${this.isotr11226.switch11 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>e</td>
                            <td>¿Los brazos realizan flexión o abducción por encima de los 20°?</td>
                            <td>
                                <v-switch v-model="isotr11226.switch12"
                                          :label="`${this.isotr11226.switch12 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si a
                                <b>todas</b> las preguntas ha contestado
                                <b>"NO"</b> entonces la tarea tiene un riesgo aceptable y está en la
                                <b>ZONA VERDE</b>.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si
                                <b>una</b> o más respuestas son
                                <b>"SI"</b>, evalúe la tarea mediante los criterios de postura dinámica explicados en
                                este capítulo a continuación.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="isotr11226!=null">
            <v-btn color="primary" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import PatientMonitoring from "../../../model/PatientMonitoring";
    import Isotr11226 from "../../../model/Isotr11226";

    export default {
        data() {
            return {
                isotr11226: null,
                listIsotr11226: [],
                valid: true,
                search: '',
                dialogError: false,
                dialogSuccess: false,
            }
        },
        methods: {
            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                this.isotr11226 = new Isotr11226();
                this.isotr11226.fecha = e
                this.listIsotr11226.push(this.isotr11226)
            },

            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.isotr11226.id != '' && this.isotr11226.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.isotr11226.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.isotr11226)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.isotr11226)
                        monitoringNew.form = 56
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.isotr11226.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 56
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.isotr11226 = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listIsotr11226 = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listIsotr11226.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

        },
        computed: {},
        created() {
            this.reloadData()
        },
    }
</script>

<style scoped>
    v-switch {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/Isotr11226.vue